module.exports = __webpack_public_path__ + "static/media/img_device.e4ecadbd.png";